import React from "react";
import {
  Box,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ZIPValidator from "../ZIPValidator/ZipValidator";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeliveryZone from "../../../img/DeliveryZone.jpg";
import "./DeliverySection.scss";

const DeliverySection = () => {
  return (
    <Box
      pl={{ md: 0, lg: 2 }}
      pb={{ xs: 0, sm: 2, md: 4, lg: 2 }}
      className="delivery-section"
    >
      <Stack spacing={4}>
        <Box pt={{ xs: 4, sm: 4, md: 0, lg: 0 }}>
          <h4 className="delivery-section__zip-header">
            Want to check if you're in our delivery zone?
          </h4>
          <p className="delivery-section__zip-copy">
            Enter your ZIP code below to check if your location is available for
            delivery.
          </p>
          <ZIPValidator />
        </Box>
        <Accordion elevation={0} disableGutters square>
          <AccordionSummary
            sx={{ px: 0, border: "none" }}
            expandIcon={<KeyboardArrowDownIcon />}
            aria-controls="delivery-zone-panel"
            id="delivery-zone-header"
          >
            <p className="location-section__accordion-title">
              Show Delivery Zone Map
            </p>
          </AccordionSummary>
          <AccordionDetails sx={{ px: 0 }}>
            <img
              width="100%"
              src={DeliveryZone}
              alt="Map of Phoenix, outlining major areas where deliveries are completed."
            />
          </AccordionDetails>
        </Accordion>
      </Stack>
    </Box>
  );
};

export default DeliverySection;
